import React, {createContext, useReducer} from 'react'
import {RouteReducer} from "../reducers/RouteReducer";

export const RouteContext = createContext();

const RouteContextProvider = (props) => {
    const state = {
        routeState: {
            inducted: 0,
            picked: 0,
            stowed: 0,
            staged: 0,
            departed: 0
        },
        routeList: [],
        metricAvailability: {
            pick: false,
            stage: false,
            depart: false,
            stow: false,
            induct: false
        }
    }
    const [ viewModel, dispatch ] = useReducer(RouteReducer, state);
    return (
        <RouteContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </RouteContext.Provider>
    )
}

export default RouteContextProvider


// WEBPACK FOOTER //
// ./src/components/routeView/context/RouteContext.js